<template>
  <div class="room-cbt-modal-component">
    <div class="room-cbt-modal flex flex-col">
      <div class="room-cbt-header">
        <h6>출제 이력</h6>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div class="min-h-0 flex-1 overflow-hidden flex flex-col">
        <div class="room-cbt-list-wrapper min-h-0 flex-1 overflow-y-auto">
          <RoomCBTLogList />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn.vue";
import RoomCBTLogList from "@/components/Room/CBT/RoomCBTLogList.vue";

export default {
  name: 'RoomCBTLog',
  components: {
    RoomCBTLogList,
    GrmCloseBtn,
  },
  created() {
    this.getCBTLogList({
      searchText: '',
      page: 1,
      size: 10,
    })
  },
  methods: {
    ...mapActions('cbt', [
      'getCBTLogList',
    ]),

    onClose() {
      this.$modal('RoomCBTLog')
    },
  }
}
</script>

<style lang="scss" scoped>
.room-cbt-modal-component {
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  z-index: 4;
  white-space: pre-line;
}
.room-cbt-modal {
  position: relative;
  width: 960px;
  height: 90vh;
  padding: 30px 30px 50px 30px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}
.room-cbt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h6 {
    font-size: 18px;
    font-weight: bold;
  }
}
.room-cbt-list-wrapper {
  margin-top: 16px;
}

// Mobile
[grm-device-mobile]{
  .room-cbt-modal-component {
    left: 0;
    .room-cbt-modal {
      width: 100%;
      height: 100%;
      max-height: none;
      border-radius: 0;
      .room-cbt-contents {
        height: calc(100% - 50px);
      }
    }
  }
}
</style>